import { React, useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import ContentSidebar from "./ContentSidebar";
import {
	InputField,
	TextAreaField,
} from "../../../components/Form/FormComponents";
import BookChapter from "./BookChapter";
import { getFormattedDate } from "../../../utils/DateUtils";

// eslint-disable-next-line no-unused-vars
function SingleBookForm({ data, setEducationData }) {
	const [formData, setFormData] = useState(data);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};
	return (
		<form className='leaseForm'>
			<ContentSidebar contentData={formData} 
			type={'book'}/>
			<div className='RightSection'>
				<FormAccordion title='Book Information' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<label>DATE / TIME</label>
							<InputField
								name='createdAt'
								handleChange={handleInputChange}
								value={getFormattedDate(formData?.createdAt)}
							/>
						</div>

						<div className='form-group'>
							<label>TITLE</label>
							<InputField
								name='name'
								handleChange={handleInputChange}
								value={formData?.name}
							/>
						</div>

						<div className='form-group'>
							<label>CATEGORY</label>
							<InputField
								name='category'
								handleChange={handleInputChange}
								value={formData?.category}
							/>
						</div>

						<div className='form-group'>
							<label>CHAPTERS</label>
							<InputField
								name='chapters'
								handleChange={handleInputChange}
								value={formData?.chapters?.length || "single chapter"}
							/>
						</div>
					</div>
				</FormAccordion>

				<FormAccordion title='Book description'>
					<div className='form-group'>
						<label>DESCRIPTION</label>
						<TextAreaField name='description' value={formData?.description} />
					</div>

					{/* <div className='form-group'>
						<label>CONTENT</label>
						<TextAreaField name='content' value={formData?.content} />
					</div> */}
				</FormAccordion>

				<FormAccordion title='Chapters'>
					<div className='form-group'>
						{formData?.chapters?.length > 0 ? (
							formData.chapters.map((data, index) => {
								return <BookChapter data={data} key={index} />;
							})
						) : (
							<BookChapter data={formData} />
						)}
					</div>
				</FormAccordion>
			</div>
		</form>
	);
}

SingleBookForm.propTypes = {
	data: PropTypes.object,
	setEducationData: PropTypes.func,
};

export default SingleBookForm;
